module.exports = __webpack_public_path__ + "static/media/11NEPAD9.c7ae3e7e.jpg";